import React from 'react';
import { TrendingUp, BarChart3, Zap } from 'lucide-react';

const BlogImage: React.FC = () => {
  return (
    <div className="relative w-full h-48 bg-gradient-to-br from-[#4ff6e6] via-[#33e6d6] to-[#1a1a1a] rounded-lg overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-4 left-4 w-8 h-8 border-2 border-white rounded-full"></div>
        <div className="absolute top-12 left-12 w-4 h-4 border-2 border-white rounded-full"></div>
        <div className="absolute top-20 left-8 w-6 h-6 border-2 border-white rounded-full"></div>
        <div className="absolute top-32 left-16 w-3 h-3 border-2 border-white rounded-full"></div>
      </div>
      
      {/* Main Content */}
      <div className="relative z-10 flex items-center justify-center h-full">
        <div className="text-center">
          <div className="flex items-center justify-center space-x-4 mb-4">
            <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
              <TrendingUp className="w-8 h-8 text-white" />
            </div>
            <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
              <BarChart3 className="w-8 h-8 text-white" />
            </div>
            <div className="w-12 h-12 bg-white/20 rounded-lg flex items-center justify-center">
              <Zap className="w-8 h-8 text-white" />
            </div>
          </div>
          <h3 className="text-white font-bold text-lg mb-2">$OPEN Case Study</h3>
          <p className="text-white/80 text-sm">SentiHype Detected the Signal</p>
        </div>
      </div>
      
      {/* Floating Elements */}
      <div className="absolute top-6 right-6 w-3 h-3 bg-white/30 rounded-full animate-pulse"></div>
      <div className="blog-image-pulse-dot blog-image-pulse-dot--delay-1 absolute bottom-8 right-12 w-2 h-2 bg-white/40 rounded-full animate-pulse"></div>
      <div className="blog-image-pulse-dot blog-image-pulse-dot--delay-2 absolute bottom-16 right-6 w-4 h-4 bg-white/20 rounded-full animate-pulse"></div>
    </div>
  );
};

export default BlogImage; 
